const megaMenu = {
  init: () => {
    document.querySelectorAll('.mega-menu li > .mega-menu__link--level-2').forEach(menuItem => {
      menuItem.addEventListener('click', () => {
        const liEl = menuItem.closest('li');
        if (liEl.classList.contains('selected')) {
          return;
        }
        const ulEl = liEl.closest('ul');
        ulEl.querySelector('li.selected').classList.remove('selected');
        liEl.classList.add('selected');
      });
    });

    const mobileLinksLvl2 = document.querySelectorAll('.menu-drawer.smrize .menu-drawer__menu-item_lvl2');
    mobileLinksLvl2.forEach(link => {
      link.addEventListener('click', () => {
        mobileLinksLvl2.forEach(otherLink => {
          if (link == otherLink) {
            return;
          }
          otherLink.closest('details').removeAttribute('open');
        });
      });
    })
  }
};

document.addEventListener("DOMContentLoaded", function () {
  megaMenu.init();
});
